import React from 'react';
import Link from 'next/link';
import { ViewSidebarOutlined, ViewSidebarRounded } from '@mui/icons-material';

import { StyledContainer, LeftSection, CollapseButton } from '@/core/components/Header/Header.styles';
import { Image } from '@/core/components/Image';

import { SignOutButton } from './SignOutButton';

interface HeaderProps {
  isCollapsed?: boolean;
  toggleSidebar?: () => void;
}

export const Header: React.FC<HeaderProps> = ({ isCollapsed, toggleSidebar }) => (
  <StyledContainer>
    <LeftSection>
      {toggleSidebar && (
        <CollapseButton onClick={toggleSidebar}>
          {isCollapsed ? 
          (
            <ViewSidebarRounded fontSize="small" sx={{ transform: 'scaleX(-1)' }} />
          ) : 
          (
            <ViewSidebarOutlined fontSize="small" sx={{ transform: 'scaleX(-1)' }} />
          )}
        </CollapseButton>
      )}
      <Link href="/">
        <a>
          <Image
            src="/images/icons/logo.svg"
            alt="Milliman Nodal"
          />
        </a>
      </Link>
    </LeftSection>
    <SignOutButton />
  </StyledContainer>
);
